



import { Component, Vue } from "vue-property-decorator";
import usuarioModule from "@/store/modules/usuario-module";
import Mapa from "@/views/gps/GpsCentros.vue";
@Component({
  components: { Mapa },
})
export default class Home extends Vue {
  public dialogNewVersion: boolean = false;
  public height = (25 * this.$vuetify.breakpoint.height) / 100;

  public created() {
    usuarioModule.getmiusuario();
  }

  public mounted() {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
      appLoading.style.display = "none";
    }
  }

  public goto(name: string) {
    this.$router.push({ name: name });
  }
}
